import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getDashboardData,getClerkDashboardData,getProvisionalOfferData,getLastInspectionData,getCustomerServiceByDate,getPropertyVisitsByDate,getPropertyVisitsByAddress} from "../actions/dashboard_action";

export default function DashboardStatistics(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getDashboardData,getClerkDashboardData,getProvisionalOfferData,getLastInspectionData,getCustomerServiceByDate,getPropertyVisitsByDate,getPropertyVisitsByAddress}, dispatch);
}

function mapStateToProps(state) {
    return {
        dashboardData: state.dashboardStats.dashboardData,
        clerkDashboardData: state.dashboardStats.clerkDashboardData,
        provisionalOfferData: state.dashboardStats.provisionalOfferData,
        lastInspectionData: state.dashboardStats.lastInspectionData,
        isDashBoardFetching:state.dashboardStats.isDashBoardFetching,
        isClerkDashBoardFetching: state.dashboardStats.isClerkDashBoardFetching,
        isProvisionalOfferFetching: state.dashboardStats.isProvisionalOfferFetching,
        isLastInspectionFetching: state.dashboardStats.isLastInspectionFetching,
        isCSDataByDateFetching: state.dashboardStats.isCSFetching,
        customerServiceDataByDate: state.dashboardStats.customerServiceDataByDate,
        propertyVisitDataByDate: state.dashboardStats.propertyVisitDataByDate,
        isPVDataByDateFetching:state.dashboardStats.isPVFetching
    };
}



// WEBPACK FOOTER //
// ./src/containers/dashboard_container.js